'use strict';

angular.module('cimerFrontEndApp').service('BookBagService', ['$q', '$http', 'ApiUrl', '$window', function ($q, $http, ApiUrl, $window) {

    var _apiUrl = ApiUrl.url('/BookBag/');
    var self = this;

    self.getMyBookBags = function () {
        var deferred = $q.defer();

        $http.get(_apiUrl + 'GetBookBagsForUser').then(function (response) {
            deferred.resolve(response.data);
        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getBookBagByID = function (id) {
        var deferred = $q.defer();

        $http.get(_apiUrl + 'GetBookBag/' + id).then(function (response) {
            deferred.resolve(response.data);
        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.saveBookBag = function (bookBagObject) {
        var deferred = $q.defer();

        $http.post(_apiUrl + 'SaveBookBag', bookBagObject).then(function (response) { deferred.resolve(response.data); }, function (err) { deferred.reject(err); });

        return deferred.promise;
    };

    self.downloadBookbag = function (bookBagObject) {
        var deferred = $q.defer();

        $http.post(_apiUrl + 'BuildDocBundle', bookBagObject).then(function (response) {
            var bundleID = response.data;
            deferred.resolve(bundleID); //pass something back to controller to end any 'downloading...' indicators
            var url = _apiUrl + 'DownloadBundle/' + encodeURIComponent(bundleID);
            $window.location = url;
        }, function (err) {
            deferred.reject(err); //error building bundle
        });

        return deferred.promise;
    };

    self.setBookBagInactive = function (bookBagObject) {
        var deferred = $q.defer();

        $http.post(_apiUrl + 'SetBookBagInactive', bookBagObject).then(function (response) { deferred.resolve(response.data); }, function (err) { deferred.reject(err); });

        return deferred.promise;
    };

    self.searchBookBags = function (userID, institutionID, disciplineID, createdDateStart, createdDateEnd) {

        var config = {
            params: {
                UserID: userID,
                InstitutionID: institutionID,
                DisciplineID: disciplineID,
                CreatedDateStart: createdDateStart,
                CreatedDateEnd: createdDateEnd
            }
        };

        return $http.get(_apiUrl + 'SearchBookBags', config);
    };
    //storing data to pass between pages
    self.saveBookBagObject = function (bookBagObject) {
        if ($window.Storage) {
            $window.sessionStorage.setItem('bookbag', angular.toJson(bookBagObject));
        }
        else {
            self.bookBag = bookBagObject;
        }
    };
    self.getBookBagObject = function () {
        if ($window.Storage) {
            return angular.fromJson($window.sessionStorage.getItem('bookbag')) || {
                bookBagID: null,
                name: "",
                description: "",
                docs: []
            };
        }
        else {
            return self.bookBag || {
                bookBagID: null,
                name: "",
                description: "",
                docs: []
            };
        }
    };
    self.clearBookBagObject = function () {
        if ($window.Storage) {
            $window.sessionStorage.removeItem('bookbag');
        }
        else {
            self.bookBag = {
                bookBagID: null,
                name: "",
                description: "",
                docs: []
            };
        }
    };
    self.bookBag = {
        bookBagID: null,
        name: "",
        description: "",
        docs: []
    };

    return self;

}]);